const invertedMessages = {
  'Start configuring your first SSO provider!': 'Auth.Title.SSOEmptyState',
  'Configure {ssoProvider}': 'Auth.Title.ConfigureSSOProvider',
  'Add {ssoProvider} Provider': 'Auth.Title.AddSSOProvider',
  'Modify {ssoProvider} Provider': 'Auth.Title.EditSSOProvider',
  'Deactivate Provider': 'Auth.Title.ConfirmSSODeactivate',
  'Activate Provider': 'Auth.Title.ConfirmSSOActivate',
  'Delete Provider': 'Auth.Title.ConfirmSSODelete',
  'Security & Attributes': 'Auth.Title.SAMLSecurityAndAttributesGroup',
  'Logout & Binding': 'Auth.Title.SAMLLogoutAndBindingGroup',
  'NameID & Principal Settings':
    'Auth.Title.SAMLNamedIDAndPrincipalSettingsGroup',
  'Basic Configurations': 'Auth.Title.SSOBasicConfigurations',
  'SSO Providers': 'Auth.Title.SSOProviders',
  'Confirm Removal': 'Auth.Title.ConfirmKeyRemoval',

  // Client Credentials
  'OAuth Client Credentials': 'Auth.Title.ClientCredentials',
  'Create Client Credential': 'Auth.Title.CreateClientCredential',
  'Edit Client Credential': 'Auth.Title.EditClientCredential',
  'Edit Client': 'Auth.Title.EditClient',
  'Delete Client': 'Auth.Title.DeleteClient',
  'Enable Client': 'Auth.Title.EnableClient',
  'Disable Client': 'Auth.Title.DisableClient',
  'Client Created Successfully': 'Auth.Title.ClientCreatedSuccessfully',
};

export default invertedMessages;
